<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <div>
              <b-row>
                <b-col sm="3">
                  <i class="fa fa-bars"></i> {{$t('str.officers')}}
                </b-col>
                <b-col sm="9"></b-col>
              </b-row>
            </div>

            <div>
              <b-row style="margin-top:10px;">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="6">{{$t('str.keyword')}}</b-col>
                    <b-col sm="3">{{$t('str.office')}}</b-col>
                    <b-col sm="3"></b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <b-form-input id="keyword" class="form-control" type="text" name="keyword"
                        :placeholder="$t('str.search')" v-model="keyword" @keyup.enter="getList()"></b-form-input>
                    </b-col>
                    <b-col sm="3">
                      <b-form-select id="office" name="office" :plain="true" v-model="office" style="height:100%;">
                        <option value="">All</option>
                        <option v-for="(c, index) in officeSelect" :value="c.value" :key="index">{{c.text}}</option>
                      </b-form-select>
                    </b-col>
                    <b-col sm="3">
                      <buttons button-type="search" @click="getList()" />&nbsp;
                      <buttons button-type="reset_filter" @click="resetFilter()" />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row style="margin-top:10px;">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="9"></b-col>
                    <b-col sm="3">
                      <router-link to="/account/officer/manage/0" class="btn-setting">
                        <buttons button-type="add_new" />
                      </router-link>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>

          <p :class="{'text-center':true, 'd-none':items.length}" class="">{{$t('str.no-data')}}</p>
          <b-table :class="{'d-none':!items.length}" :hover="hover" :striped="striped" :bordered="bordered"
            :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
            <template slot="is_active" slot-scope="data">
              <b-button v-if="data.item.is_active == 0" variant="success" size="sm"
                @click="activateOfficer(data.item.id)">
                <i class="fa fa-power-off"></i>&nbsp;{{ $t('str.activate') }}
              </b-button>
              <b-button v-if="data.item.is_active == 1" variant="danger" size="sm"
                @click="suspendOfficer(data.item.id)">
                <i class="fa fa-power-off"></i>&nbsp;{{ $t('str.suspend') }}
              </b-button>
            </template>
            <template slot="action" slot-scope="data">
              <router-link :to="'/account/officer/manage/'+data.item.id">
                <buttons button-type="edit" />
              </router-link>
              &nbsp;
              <buttons button-type="delete" @click="confirmDelete(data.item.id)" />
            </template>
          </b-table>
          <nav :class="{'d-none':!items.length}">
            <paging :current-page="currentPage" :total-pages="totalPage" @page-changed="pageOneChanged" prev-text="Prev"
              next-text="Next" />
          </nav>
        </b-card>
      </b-col>
    </b-row>
    <confirm-modal :item="confirmDeleteId" @confirm="deleteData" @cancel="cancelDelete"></confirm-modal>
  </div>
</template>

<script>
import axios from 'axios'

import Pagination from '@/views/component/Pagination'
import ConfirmModal from '@/views/component/ConfirmModal'
import Buttons from '@/views/component/Buttons'

export default {
  name: 'Officer',
  components: {
    'paging': Pagination,
    'confirm-modal': ConfirmModal,
    'buttons': Buttons
  },
  props: {
    hover: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false }
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'name', sortable: true },
        { key: 'email', sortable: true },
        { key: 'office_name', sortable: true },
        { key: 'is_active', sortable: true },
        { key: 'action' }
      ],
      keyword: '',
      currentPage: 1,
      totalPage: 0,
      confirmModal: false,
      confirmDeleteId: '',
      office: '',
      officeSelect: []
    }
  },
  methods: {
    async getOfficeSelect() {
      this.$auth.checkSession()
      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Office`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        let cData = getData.data.data

        for (let i = 0; i < cData.length; i++) {
          this.officeSelect.push({ 'value': cData[i].id, 'text': cData[i].name })
        }
      } catch (e) {
        console.log(e.response)
      }
    },
    async getList(page) {
      this.$auth.checkSession()
      var trail = `?limit=${this.$helper.envi.VUE_APP_PAGING_LIMIT}`
      if (page) trail = `${trail}&page=${page}`
      if (this.keyword != '') trail = `${trail}&keyword=${this.keyword}`
      if (this.office != '') trail = `${trail}&office=${this.office}`

      try {
        var getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Admin/Officer${trail}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.items = getData.data.data
        this.currentPage = getData.data.meta.page
        this.totalPage = getData.data.meta.pageCount
      } catch (e) {
        console.log(e.response)
      }
    },
    async deleteData(id) {
      this.$auth.checkSession()
      try {
        var result = await axios.delete(`${this.$helper.envi.VUE_APP_API_URL}/Admin/Officer/${id}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.$toast.success(result.data.meta.message, '', {
          position: 'topCenter'
        })

        this.getList()
        this.confirmModal = false
      } catch (e) {
        console.log(e.response)
      }
    },
    async activateOfficer(id) {
      this.$auth.checkSession()
      try {
        let result = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Admin/Officer/${id}/Activate`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.$toast.success(result.data.meta.message, '', {
          position: 'topCenter'
        })

        this.getList()
      } catch (e) {
        console.log(e.response)
      }
    },
    async suspendOfficer(id) {
      this.$auth.checkSession()
      try {
        let result = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Admin/Officer/${id}/Suspend`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.$toast.success(result.data.meta.message, '', {
          position: 'topCenter'
        })

        this.getList()
      } catch (e) {
        console.log(e.response)
      }
    },
    resetFilter() {
      this.keyword = ''
      this.getList()
    },
    pageOneChanged(pageNum) {
      this.$auth.checkSession()
      this.currentPage = pageNum
      this.getList(pageNum)
    },
    confirmDelete(id) {
      this.$auth.checkSession()
      this.confirmModal = true
      this.confirmDeleteId = id
    },
    cancelDelete() {
      this.$auth.checkSession()
      this.confirmModal = false
    }
  },
  created() {
    this.getOfficeSelect()
    this.getList()
  }
}
</script>